<template>
    <figure class="ui-advantage">
        <div class="ui-advantage-image-wrapper">
            <nuxt-img
                :src="advantage.iconSrc"
                :alt="advantage.iconAlt || ''"
                format="webp"
                class="ui-advantage__image"
            />
        </div>
        <figcaption
            class="ui-advantage__description"
            v-html="advantage.description"
        />
    </figure>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'UIAdvantage',
    props: {
        advantage: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/ui-advantages/advantage';
</style>
